import React from "react";
import PropTypes from "prop-types";
import styled from "theme/libs/styled";

const Strong = styled("strong")`
    font-weight: 600;
`;

const Bold = ({ children }) => <Strong>{children}</Strong>;

Bold.propTypes = {
    children: PropTypes.node.isRequired,
};

export default Bold;
